import { render, staticRenderFns } from "./StudentVoucherStatus.vue?vue&type=template&id=239707d4&"
import script from "./StudentVoucherStatus.vue?vue&type=script&lang=js&"
export * from "./StudentVoucherStatus.vue?vue&type=script&lang=js&"
import style0 from "./StudentVoucherStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports